// extracted by mini-css-extract-plugin
export default {"comment":"Comment__comment___bv71S"};